import { PROJECT_REPO_URL } from "../../app/projectLinks";

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="container footer-inner">

        <div className="footer-story">
          <p className="footer-story-text">
            I built this because I got tired of uploading documents to random
            websites — most of them sketchy, none of them transparent about
            what happens to your files. Everything here runs entirely in your
            browser. <strong>Your files never leave your device.</strong> The
            code is public, so you don't have to take my word for it.
          </p>
          <a
            className="footer-gh-link"
            href={PROJECT_REPO_URL}
            target="_blank"
            rel="noreferrer"
          >
            <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0 1 12 6.844a9.59 9.59 0 0 1 2.504.337c1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.02 10.02 0 0 0 22 12.017C22 6.484 17.522 2 12 2z" />
            </svg>
            View source on GitHub
          </a>
        </div>

        <div className="footer-privacy">
          <p className="footer-privacy-heading">How privacy works</p>
          <ul className="footer-privacy-list">
            <li>
              <span className="footer-privacy-icon">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></svg>
              </span>
              <span><strong>All processing is local.</strong> Conversions, parsing, and rendering happen entirely in your browser using WebAssembly and JavaScript.</span>
            </li>
            <li>
              <span className="footer-privacy-icon">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>
              </span>
              <span><strong>No file uploads.</strong> There is no server. Your documents never leave your device — not even in encrypted form.</span>
            </li>
            <li>
              <span className="footer-privacy-icon">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" /><line x1="1" y1="1" x2="23" y2="23" /></svg>
              </span>
              <span><strong>Zero tracking.</strong> No analytics, no telemetry, no cookies, no fingerprinting. Nothing is collected.</span>
            </li>
          </ul>
        </div>

      </div>
      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <span>Serverless Converter — public source, runs in your browser</span>
          <span className="footer-bottom-muted">No backend · No uploads · No tracking</span>
        </div>
      </div>
    </footer>
  );
}
